<template>
  <div> 
    <v-app v-if="selected_object.length==0" class="ma-2" style="background:#eee">
      <v-sheet>
        <v-container id="dashboard" fluid tag="section">
          <center class="mt-12 pt-12">
            <v-icon class="mt-12" size="100" color="grey --darken-2">mdi-car-off</v-icon>
            <h3 class="pt-5">No Asset Selected</h3>
            <p class="title pt-5">Select an asset to view the asset info</p>
          </center>
        </v-container>
      </v-sheet>
    </v-app> 
    <v-app v-if="selected_object.length>0">
      <v-container id="dashboard" fluid tag="section">
        <v-toolbar
          dark
          v-bind:color="!objectsOnly[0]?.engineon ||''? 'grey lighten-1':'green lighten-1' "
        >
          <v-toolbar-title>
            <h3 class="font-weight-light">
              <span>
                <v-icon large>mdi-truck</v-icon>
              </span>
              {{ objectsOnly[0]?.name || '' }}
            </h3>
            {{ !objectsOnly[0]?.engineon  ||''? 'Engine Off':'Engine On' }}
          </v-toolbar-title>
        </v-toolbar>

        <v-row>
          <v-col cols="12" sm="6" lg="3">
            <base-stat-tile
              title="Mileage"
              :value="mileage"
              icon="mdi-road-variant"
              accent="#2962ff"
              hint="Last 7 days"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-stat-tile
              title="Fuel"
              :value="drivers"
              icon="mdi-fuel"
              accent="#00bfa5"
              hint="Estimated litres, last 7 days"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-stat-tile
              title="Trips"
              :value="trips"
              icon="mdi-map-marker-path"
              accent="#7c4dff"
              hint="Covered in last 7 days"
            />
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <base-stat-tile
              title="Odometer Reading"
              :value="odometerReading()"
              icon="mdi-car-cruise-control"
              accent="#ff9100"
              hint="Current reading (KM)"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <base-material-chart-card
              :data="paymentsChart.data"
              :options="paymentsChart.options"
              :responsive-options="paymentsChart.responsiveOptions"
              color="#E91E63"
              hover-reveal
              type="Line"
            >
              <h4 class="card-title font-weight-light mt-2 ml-2">
                <v-icon>mdi-fuel</v-icon>Estimated Fuel Consumption
              </h4>
              <p class="d-inline-flex font-weight-light ml-2 mt-1">Last 7 days(litres)</p>
              <p class="font-weight-light">
                Fuel Consumed (today)
                <b>{{todayfuel}} ltrs</b>
              </p>
            </base-material-chart-card>
          </v-col>

          <v-col cols="6">
            <base-material-chart-card
              :data="tripsChart.data"
              :options="tripsChart.options"
              :responsive-options="tripsChart.responsiveOptions"
              color="success"
              hover-reveal
              type="Line"
            >
              <h4 class="card-title font-weight-light mt-2 ml-2">
                <v-icon>mdi-road-variant</v-icon>Mileage
              </h4>
              <p class="d-inline-flex font-weight-light ml-2 mt-1">Vehicle Movement (Last 7 days)</p>
              <p class="font-weight-light">
                Distance Travelled (today)
                <b>{{todaymileage}} KM</b>
              </p>
            </base-material-chart-card>
          </v-col>
        </v-row>

        <v-card class="pa-5">
          <v-row>
            <v-col style="height:400px">
              <div id="mapid" style="height: 100%; width: 100%;"></div>
            </v-col>

            <v-col>
              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">CURRENT LOCATION</v-list-item-title>
                        <v-list-item-subtitle
                          class="body-1"
                        >{{objectsOnly[0]?.current_loc || ''}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">LAST REPORTING TIME</v-list-item-title>
                        <v-list-item-subtitle
                          class="body-1"
                        >{{ last_reporting_time }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">LAST UPDATE</v-list-item-title>
                        <v-list-item-subtitle
                          class="body-1"
                        >{{ last_update_label }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">DATA LINE</v-list-item-title>
                        <v-list-item-subtitle class="body-1">{{objectsOnly[0]?.sim_number || ''}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">IMEI</v-list-item-title>
                        <v-list-item-subtitle class="body-1">{{objectsOnly[0]?.imei || ''}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">Speed KPH</v-list-item-title>
                        <v-list-item-subtitle
                          class="body-1"
                        >{{objectsOnly[0]?.speed }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">GPS CO-ORDS</v-list-item-title>
                        <v-list-item-subtitle
                          class="body-1"
                        >{{objectsOnly[0]?.lat +','+ objectsOnly[0]?.lng  }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="body-1">
                          <v-icon color="red">mdi-alert</v-icon>&nbsp;Alerts (today)
                        </v-list-item-title>
                        <v-list-item-subtitle class="body-1">{{todayevents}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-app> 
  </div>
</template>

<style>
#dashboard {
  background: #eee;
}

.map {
  position: relative;
  height: 100% !important;
  z-index: 2 !important;
}
</style>

<script>
import { mapMutations, mapState } from "vuex";
import common from "../mixins/common";
import kensrin_map, { formatTrackerTime, relativeAge } from "../mixins/kensrin_map";
import moment from "moment";
import { getGroupedAssets } from "@/services/assetsDb";

export default {
  name: "AssetInfo",
  data() {
    return {
      all_assets: [],
      objectsOnly: [],
      asset_groups: [],
      nowMs: Date.now(),
      agetimer: null,

      drivers: 0,
      mileage: 0,
      todaymileage: 0,
      todayfuel: 0,
      todayevents: 0,
      trips: 0,

      registration: "",
      searchloading: false,

      m_notification: [],
      loading: false,
      paymentsChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[0, 0, 0, 0, 0, 0, 0]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      tripsChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[0, 0, 0, 0, 0, 0, 0]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          axisX: {
            showGrid: true
          },
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }
    };
  }, 
  async mounted() {   
    const payload = await getGroupedAssets(this.session.account[0].username); 
    if(payload.length > 0) {  
      this.all_assets = payload;   
      const current = payload.find(g => g.text === this.selected_group);
      this.objectsOnly = (current ? current.children : []).filter(g => g.imei === this.selected_object[0]);  
      this.asset_groups = (current || {}).children || [];
    } 
    if (this.selected_object.length > 0) { 
      this.available_data();
    }
    // Keep the "last update" label ageing while this page stays open: the delta
    // poll drops an idle asset, so nothing else would re-render it.
    this.agetimer = window.setInterval(() => {
      this.nowMs = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.agetimer);
  },
  computed: {
    ...mapState(["notification", "selected_object","selected_group"]),
    // The API's dt_tracker already carries the account timezone; only reformat it.
    last_reporting_time() {
      return formatTrackerTime(this.objectsOnly[0] && this.objectsOnly[0].dt_tracker);
    },
    // Live age of the last fix. The server's `last_update.update` string is
    // frozen (the delta poll never refreshes an asset that stopped reporting),
    // so it is recomputed from the absolute fix instant instead.
    last_update_label() {
      return relativeAge(this.objectsOnly[0], this.nowMs);
    }
  },
  mixins: [common,kensrin_map], 
  methods: {
    setNotification(t, m) {
      this.m_notification["msg"] = m;
      this.m_notification["type"] = t;
      this.$store.commit("SET_NOTIFICATION", this.m_notification);
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
    odometerReading() {
      const value = parseFloat(this.objectsOnly[0] && this.objectsOnly[0].odometer);
      return isNaN(value) ? "" : value.toFixed(2);
    },
    available_data() {
      this.mileage = "....";
      this.drivers = "....";
      this.trips = "....";
      this.todaymileage = ".....";
      this.todayfuel = ".....";
      this.tripsChart.data.labels = [];
      this.paymentsChart.data.labels = [];
      this.tripsChart.data.series = [[]];
      this.paymentsChart.data.series = [[]];

      this.http_connect_node("/vehicle_status", {
        token: this.check_token(),
        dtf:
          moment
            .utc()
            .subtract(7, "days")
            .format("YYYY-MM-DD") + " 00:00:00",
        dtt: moment.utc().format("YYYY-MM-DD") + " 23:59:59",
        imei: this.$store.state.selected_object[0]
      })
        .then(res => {
          if (res.status == 200) {
            const d = res.data || {};

            // New, simpler contract (Node aggregator): summary fields + a daily
            // breakdown. No positional drive arrays, no fuel model.
            this.mileage = (d.route_length || 0).toFixed(2).toLocaleString();
            this.drivers = (d.fuel_consumption || 0).toFixed(2).toLocaleString();
            this.trips = (d.trips_count || 0).toLocaleString();
            this.todaymileage = (d.today_distance || 0).toFixed(2).toLocaleString();
            this.todayfuel = (d.today_fuel || 0).toFixed(2).toLocaleString();
            this.todayevents = d.events_today || 0;

            this.tripsChart.data.labels = [];
            this.tripsChart.data.series[0] = [];
            this.paymentsChart.data.labels = [];
            this.paymentsChart.data.series[0] = [];

            (d.daily || []).forEach(day => {
              const label = moment(day.date, "YYYY-MM-DD").format("ddd DD");
              this.tripsChart.data.labels.push(label);
              this.tripsChart.data.series[0].push(Number((day.distance_km || 0).toFixed(2)));
              this.paymentsChart.data.labels.push(label);
              this.paymentsChart.data.series[0].push(Number((day.fuel || 0).toFixed(2)));
            });
          }
        })
        .catch(err => { console.error("[Asset_info] vehicle_status failed:", err); });
    }
  },
  watch: {
    "$store.state.selected_object": function() {
      if (this.selected_object.length === 0) return;

      const imei = this.selected_object[0];
      let group = this.all_assets.find(g => g.text == this.selected_group);
      let asset = group ? (group.children || []).find(c => c.imei === imei) : null;
      if (!asset) {
        // Group may be missing/stale — find the group that actually owns it.
        group = this.all_assets.find(g => (g.children || []).some(c => c.imei === imei));
        asset = group ? group.children.find(c => c.imei === imei) : null;
      }
      if (group) this.asset_groups = group.children;
      this.objectsOnly = asset ? [asset] : [];

      // #mapid only exists once an asset is selected, so initialise it now if
      // this page was opened in the "no asset" empty state.
      this.$nextTick(() => this.initMap());
      this.available_data();
    }
  }
};
</script>
